import { render, staticRenderFns } from "./secretary_mailbox.vue?vue&type=template&id=54dd7aaa&"
import script from "./secretary_mailbox.vue?vue&type=script&lang=js&"
export * from "./secretary_mailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports